angular.module('Itao.IndicatorMap').directive('districtRadios', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtRadios.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '='
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];

      jQuery('#districtToggle').click(function () {
        jQuery(this).closest('.district-container').toggleClass('open');
      });

      // Toggle selection for a given district by key
      scope.toggleSelection = function toggleSelection(district) {
        scope.selectedDistrict = +district.uid;
      };

      scope.$watch('selectedDataLayer', function (dataLayer) {
        if (dataLayer && dataLayer.hasOwnProperty('districts')) {
          var oldKeys = angular.copy(scope.disabledDistrictKeys);
          var newKeys = Object.keys(dataLayer.districts).map(function (num) {
            return dataLayer.districts[num].key;
          });
          angular.forEach(oldKeys, function (oldKey) {
            if (newKeys.indexOf(oldKey) === -1) {
              scope.disabledDistrictKeys.splice(scope.disabledDistrictKeys.indexOf(oldKey), 1);
            }
          });
        }
      });
    }
  };
}]);
